import React, { useState } from 'react';
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { useGetDisciplines } from 'helpers/commonCodes';


export const Discipline = ({ code, description, showDescription = true, className }) => {
    const { mirs_competition } = useUrlFriendlyToParameters();
    const [showImage, setShowImage] = useState(true);
    const hideImg = () => {
        setShowImage(false);
    };
    const params = useUrlFriendlyToParameters()
    let competition = mirs_competition !== undefined ? mirs_competition : process.env.REACT_APP_DEFAULT_COMPETITION
    const allDisciplines = useGetDisciplines(params);
    let disciplineDescrip = allDisciplines?.disciplines?.find(row => row?.code === code)?.description
    description = description ? description : disciplineDescrip
    return (
        <>
            {showImage ? (
                <img aria-hidden="true"
                    className={className}
                    src={`/assets/images/sports/${competition}/Dark/${code}.png`}
                    alt={description}
                    onError={hideImg} />
            ) : (
                code
            )}
            {showDescription && description}
        </>

    )
};

export const DisciplineMemo = React.memo(Discipline);

export default Discipline

